/**
 * @Description: Header中导航组件
 * @Autho: 人杰
 * @Date:2019/10/18 11:23
 */

import React, {Component} from 'react';
// 路由对象
import {withRouter} from 'react-router-dom';
// Cookie对象
import Cookie from 'js-cookie';
// 引入antd的组件
import {Dropdown, Form, Icon, Menu, message, Button, Select} from 'antd';

import {observe} from "mobx";
import {inject, observer} from "mobx-react";
import {map} from 'lodash';
import classNames from 'classnames';
import {TreeSelect} from 'antd';

const {TreeNode} = TreeSelect;
const Option = Select.Option;


class IconList extends Component {

    

    render() {
        //console.log("IconList render")

        return (
            <div onClick={(e) => this.props.onClick('aaa')} >aaa</div>
        )
    }
}

export default IconList


// WEBPACK FOOTER //
// ./src/widget/HeaderBar/ChildHeader/IconList/IconList.jsx